import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  queueMetaData,
} from './configStructure';
import EmptyState from 'Components/EmptyState/EmptyState';
import { getTranslations } from './configStructure';
import './CreateCustomQueueLanding.scss';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { connect } from 'react-redux';
import { fetchDataColumns } from 'Actions/dataColumnsAction';
import {
  dangerNotificationBanner,
  closeNotificationBanner,
} from 'Actions/notificationAction';
import { setCords, resetCords } from 'Actions/floatingPanelAction';
import {
  formatAvailableFilters,
  formatActiveFilters,
  splitMergedElementIdsFilters,
  mapActiveFilters,
  convertJsonObjectToArray,
  splitMergedElementIdsFilterValues,
  mapSavedFilters,
  addCreateQueueFilterValidations,
} from 'Utils/dynamicListSelectorUtil';
import { each } from 'Utils/lodashUtils.js'
import { loadState } from '../../store/browserStorage';
import { getUrlSearchParamValue } from 'Utils/urlUtils';
import {
  getFilterValuesBasedOnElementId,
  getFilterValuesBasedOnElementIdWithAcquirer,
  urlRelativeMapping,
  fetchParticipantDetails
} from 'Apis/caseDataAPI.js';
import classnames from 'classnames';
import CustomQueueFilterPane from 'Components/CustomQueueFilterPane';
import {
  getFiltersBasedOnSearchTypeId,
  getSortOrderToCustomQueuePage,
  getSortFiltersParamToCustomQueuePage,
} from 'Apis/searchFilterApi';
import * as KeyConstants from 'Utils/constants/keyConstants.js';

import QueueList from 'Components/QueueList';
import { setSearchOpenFlag } from 'Actions/drawerAction';
import DropDownList from 'Components/DropDownList/DropDownList';
import { getGeneralQueueMetaData, getPendingCases } from './configStructure.js';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { isObject } from 'util';
import {
  getDataForQueueMgmtLanding,
  getQueueData,
  getQueueGroupList,
  getCategoryLabels,
  getQueueLabels,
  getSubQueueList,
  getBaseQueueGroupList,
  postCreateQueueFilters,
  deleteSubQueue,
  postUpdateQueueFilters,
  updateQueueVisibility,
  urlMapping,
  fetchFilterValuesBasedOnElementId
} from 'Apis/queueManagerApi.js';
import CaseCountDetail from 'Components/CaseCountDetail/CaseCountDetail';
import ResponseBanner from 'Components/cards/ResponseBanner';
import ImagePortal from '../ImagePortal/ImagePortal';
import { VITE_AVAILABLE_QUEUES, VITE_CQ_FILTERS_SEARCH_TYPE_ID } from 'Constants/appEnvConstants';

var Labels;
let responseData = [];

export class CreateCustomQueueLanding extends Component {

  constructor(props) {
    super(props);
    let defaultSortCount = 1;
    this.userIdByLogin = getUrlSearchParamValue(this.props.location.search, 'userid');
    this.state = {
      isVisible: false,
      filters: [],
      isLoading: true,
      scrollPos: 0,
      caseData: [],
      appliedFilters: [],
      sort: queueMetaData().defaultSort,
      dateFormat: queueMetaData().dateFormat,
      filterText: '',
      isRequiredFilter: false,
      isLoadingComplete: true,
      isRefreshed: false,
      dataColumns: [],
      queueMetaData: queueMetaData(),
      currentGroupAnalysts: [],
      casesToHide: [],
      totalBulkCases: 0,
      resetCaseCount: false,
      totalRecordsUpdated: -1,
      scrollPos: 0,
      activeFiltersValues: [],
      activeSortFiltersValues: [],
      activeExclusionFiltersValues: [],
      activeFilters: [],
      availableFilters: [],
      activeSortFilters: [],
      availableSortFilters: [],
      activeExclusionFilters: [],
      availableExclusionFilters: [],
      isBookMarked: false,
      filterTypeId: 0,
      exportFilterTypeId: 0,
      dropdownToggled: {
        active: false,
        inactive: false,
      },
      finalFilterElements: [],
      apiMultiSelectCount: 0,
      isRequiredFilter: false,
      saveFilterToggled: false,
      filterName: '',
      noSavedFilters: false,
      savedFilters: [],
      currentSearchTerm: '',
      savdActiveFilters: [],
      tempSavedFilters: [],
      queueSearchView: {
        "filterTypeId": 0,
        "searchFilterInputElements": []
      },
      saveFilterFail: false,
      setSize: false,
      sortArr: queueMetaData().defaultSort,
      isCurrentlySavedFilters: false,
      dynamicFilterFlag: false,
      formattedFilters: [],
      formattedActiveSortFilters: [
        {
          id: `sort_${defaultSortCount}`,
          elementCategoryName: "EXACT",
          elementTypeName: "DROPDOWN",
          elementId: `sort_${defaultSortCount}`,
          elementMandatory: true,
          updatedId: `sort_${defaultSortCount}`,
          elementSection: "sort",
          actualNameId: `sort_${defaultSortCount}`,
          elementLabel: `Sort ${defaultSortCount}`,
          name: `Sort ${defaultSortCount}`,
          values: null,
          category: "EXACT",
          elementType: "DROPDOWN",
          dropdownType: "sort",
          v1: "cb",
        },
        {
          id: `sort_odr_${defaultSortCount}`,
          elementCategoryName: "EXACT",
          elementTypeName: "DROPDOWN",
          elementId: `sort_odr_${defaultSortCount}`,
          elementMandatory: true,
          updatedId: `sort_odr_${defaultSortCount}`,
          elementSection: "sort",
          actualNameId: `sort_odr_${defaultSortCount}`,
          elementLabel: `Sort Order ${defaultSortCount}`,
          name: `Sort Order ${defaultSortCount}`,
          values: null,
          category: "EXACT",
          elementType: "DROPDOWN",
          dropdownType: "sort_odr",
          v1: "ASC",
        },
      ],
      formattedAvailableSortFilters: [],
      formattedExclusionFilters: [],
      userIdState: this.userIdByLogin,
      statusErrorCode: 0,
      queueLabels: [],
      categoryLabels: [],
      regionDataList: [],
      buttonAnalyst: true,
      buttonInternal: false,
      buttonMerchant: false,
      queueSummaryCount: [],
      totalQueueCount: [],
      queueList_1: [],
      queueList_2: [],
      queueList_3: [],
      queueListData: [],
      queueDefaultListData: [],
      queueExceptionListData: [],
      selectedInput: [],
      emptyStateHeading: 'Unauthorized',
      emptyStateDescription: 'You are not authorized to view this content.',
      emptyStateNoPermissionsHeading: 'You do not have permission to view this page',
      emptyStateNoPermissionsDesc: 'Please contact support team for further assistance',
      isUpdate: false,
      updateValues: [],
      isCreated: false,
      selectedQueue: {},
      isUpdatedSuccess: false,
      isQueueActive: false,
      isQueueInactive: false,
      isDeleteWarning: false,
      showErrorBanner: false,
      isCreateFailure: false,
      isUpdateWarning: false,
    };
    this.attachBindings();
    this.attachListeners();
  }

  attachListeners() {
    // TODO: Add any event lister required.
  }

  attachBindings() {
    this.onKeyDown = this.onKeyDown.bind(this);
    this.closeFilterPane = this.closeFilterPane.bind(this);
    this.toggleFilterPane = this.toggleFilterPane.bind(this);
    this.resetScrollPos = this.resetScrollPos.bind(this);
    this.updateColumnsInfo = this.updateColumnsInfo.bind(this);
    this.updateExclusionColumnsInfo = this.updateExclusionColumnsInfo.bind(this);
    this.getFiltersBasedOnSearchTypeId = this.getFiltersBasedOnSearchTypeId.bind(this);
    this.formatResponseCommon = this.formatResponseCommon.bind(this);
    this.saveActiveDynamicFilters = this.saveActiveDynamicFilters.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.clearAllFilters = this.clearAllFilters.bind(this);
    this.checkSize = this.checkSize.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.getFormattedResponse = this.getFormattedResponse.bind(this);
    this.getMultiSelectFilterValues = this.getMultiSelectFilterValues.bind(this);
    this.getExclusionFilterValues = this.getExclusionFilterValues.bind(this);
    this.getSelectSortFilterValues = this.getSelectSortFilterValues.bind(this);
    this.updateIsIndeterminate = this.updateIsIndeterminate.bind(this);
    this.getFormattedResponseCorpRegion = this.getFormattedResponseCorpRegion.bind(this);
    this.groupByRegion = this.groupByRegion.bind(this);
    this.clearGroupSearchValue = this.clearGroupSearchValue.bind(this);
    this.changeButton = this.changeButton.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    this.getQueueGroupList = this.getQueueGroupList.bind(this);
    this.fetchQueueLabels = this.fetchQueueLabels.bind(this);
    this.getCategoryLabels = this.getCategoryLabels.bind(this);
    this.getSubQueueList = this.getSubQueueList.bind(this);
    this.isThreeDots = this.isThreeDots.bind(this);
    this.reLoadFullPage = this.reLoadFullPage.bind(this);
    this.showBanner = this.showBanner.bind(this);
    this.deleteSubQueue = this.deleteSubQueue.bind(this);
    this.updateQueueVisibility = this.updateQueueVisibility.bind(this);
  }

  componentWillMount() {
    scroll(0, 0);
    document.addEventListener('keydown', this.onKeyPres);
    document.addEventListener('keypress', this.onKeyPress);

    const auth = loadState('auth');
    const userPermission = auth !== undefined && auth.user !== undefined ? auth.user.parsedPermissions : undefined;
    this.setState({
      generalQueueMetaData: getGeneralQueueMetaData(),
      pendingCases: getPendingCases(),
      userPermission,
    });
    this.getFiltersBasedOnSearchTypeId(VITE_CQ_FILTERS_SEARCH_TYPE_ID);
    this.getQueueGroupList();
  }

  componentDidMount() {
    this.setState({
      sort: Object.assign([], queueMetaData().defaultSort),
    })
    let acquirerAccessList = getAcquirerAccessList();
    this.getCategoryLabels();
    this.fetchQueueLabels();
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyPress);
    document.removeEventListener('keypress', this.onKeyPress);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  reLoadFullPage() {
    window.location.reload();
    this.setState({
      isCreated: false,
      isDeleteSuccess: false,
      isUpdatedSuccess: false,
      queueDeletedException: false,
    });
  }

  getFormattedResponse(response, filter) {
    let filterValues = [];
          switch (filter) {
            case 'cq_participantId':
              response.data.participantIds.forEach(id => {
                filterValues.push({
                  value: id,
                  text: id,
                });
              });
              break;

            case 'cq_businessLine':
              response.data.businessLines.forEach(item => {
                filterValues.push({
                  value: item,
                  text: item,
                });
              });
              break;

            case 'cq_fiid':
              response.data.fiids.forEach(item => {
                filterValues.push({
                  value: item,
                  text: item,
                });
              });
              break;

            default:

                response.data.forEach((filterValue, index) => {
                  if (filter === 'cq_case_type') {
                    filterValues = filterValues.concat({
                      id: filterValue.stageId.toString(),
                      value: filterValue.stageId.toString(),
                      text: filterValue.stageName,
                    });
                  }
                  if (filter === 'cq_case_status') {
                    filterValues = filterValues.concat({
                      id: filterValue.statusId.toString(),
                      value: filterValue.statusId.toString(),
                      text: filterValue.statusName,
                    });
                  }

                  if (filter === 'hpy_petro_name') {
                    filterValues = filterValues.concat({
                      id: filterValue.petroPayId,
                      value: filterValue.petroPayId,
                      text: filterValue.petroPayName,
                    });
                  }

                  if (filter === 'cq_card_brand') {
                    filterValues = filterValues.concat({
                      value: filterValue.cardBrandCode.toString(),
                      text: filterValue.cardBrandName.toString(),
                    });
                  }

                  if (filter === 'cq_portfolio') {
                    filterValues = filterValues.concat({
                      value: filterValue.acquirerCode.toString(),
                      text: filterValue.acquirerDescription.toString(),
                    });
                  }

                  if (filter === 'cq_pend_indicator') {
                    filterValues = filterValues.concat({
                      value: filterValue.pendIndicatorCode.toString(),
                      text: filterValue.pendIndicatorDesc.toString(),
                    });
                  }

                  if (filter === "cq_assigned_to") {
                    filterValues = filterValues.concat({
                      value: filterValue.value,
                      text: filterValue.name,
                    });
                  }

                  if ((filter).slice(0, (filter).lastIndexOf('_')) === 'sort' || (filter).slice(0, (filter).lastIndexOf('_')) === 'sort_odr') {
                    filterValues = filterValues.concat({
                      value: filterValue.value,
                      text: filterValue.text,
                    });
                  }
                });

                if (filter === 'cq_label') {
                  let labelResponse = response.data.filter(obj => obj.queueIndicator == "1");
                  labelResponse.forEach((filterValue, index) => {
                    filterValues = filterValues.concat({
                      value: filterValue.queueCategoryCode,
                      text: filterValue.queueDescription,
                    });
                  });
                }

                if (filter === 'cq_ex_corp_region' || filter === 'cq_reason_code' || filter === 'cq_activity_code'
                  || filter === 'cq_action_code' || filter === 'cq_dispute_currency'
                  || filter === 'cq_trnsctn_currency' || filter === 'cq_sttlmnt_crrncy'
                  || filter === 'cq_dspstn_ctgry' || filter === 'cq_mcc' || filter === 'cq_base_queue') {
                  filterValues = this.getFormattedResponseCorpRegion(response.data, filter);
                  filterValues = this.groupByRegion(filterValues, filter);
                }
              }
     return filterValues;
  }

  getFormattedResponseCorpRegion(corpRegionResponse, filter) {
    let filterValues = [];
    if (filter === 'cq_ex_corp_region') {
      corpRegionResponse.forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.regionCode,
          value: filterValue.regionCode,
          text: filterValue.regionCode,
          groupName: filterValue.corp,
          groupId: filterValue.corp,
        });
      });
    } else if (filter === 'cq_reason_code') {
      corpRegionResponse.forEach((filterValue) => {
        filterValues = filterValues.concat({
          id: filterValue.reasonCode,
          value: filterValue.reasonCode,
          text: `${filterValue.reasonCode} : ${filterValue.resonCodeDesc}`,
          groupName: filterValue.cardBrandName,
          groupId: filterValue.cardBrandCode,
        });
      });
    } else if (filter === 'cq_action_code') {
      corpRegionResponse.forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.actionCode,
          value: filterValue.actionCode,
          text: filterValue.actionDescription,
          groupName: filterValue.actionCode,
          groupId: filterValue.actionCode,
        });
      });
    } else if (filter === 'cq_activity_code') {
      corpRegionResponse.forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.dispositionCode,
          value: filterValue.dispositionCode,
          text: filterValue.dispositionDescription,
          groupName: filterValue.dispositionCode,
          groupId: filterValue.dispositionCode,
        });
      });
    } else if (filter === 'cq_dispute_currency' || filter === 'cq_trnsctn_currency' || filter === 'cq_sttlmnt_crrncy') {
      corpRegionResponse.forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.currencyCode,
          value: filterValue.currencyCode,
          text: filterValue.currencyDescription,
          groupName: filterValue.currencyCode,
          groupId: filterValue.currencyCode,
        });
      });
    } else if (filter === 'cq_dspstn_ctgry') {
      corpRegionResponse.filter(obj => obj.categoryType == "disposition").forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.categoryCode,
          value: filterValue.categoryCode,
          text: filterValue.categoryDescription,
          groupName: filterValue.categoryType,
          groupId: filterValue.categoryType,
        });
      });
    } else if (filter === 'cq_mcc') {
      corpRegionResponse.forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.mccCode,
          value: filterValue.mccCode,
          text: filterValue.mccDescription,
          groupName: filterValue.mccCode,
          groupId: filterValue.mccCode,
        });
      });
    } else if (filter === "cq_base_queue") {
      corpRegionResponse.forEach((filterValue, index) => {
        filterValues = filterValues.concat({
          id: filterValue.subCategoryCode,
          value: filterValue.subCategoryName,
          text: filterValue.subCategoryName,
          groupName: filterValue.cateogoryName,
          groupId: filterValue.categoryCode,
        });
      });
    }
    return filterValues;
  }

  groupByRegion(filterlist, filter) {
    let grp = filterlist.reduce((previous, current) => {
      let nameParts = current.groupName;
      if (!previous[nameParts]) {
        previous[nameParts] = [Object.assign({}, current)];
      } else {
        previous[nameParts].push(Object.assign({}, current));
      }
      return previous;
    }, {});
    let group = Object.keys(grp).map(key => ({ key, items: grp[key], cardBrandCode: grp[key][0].cardBrandCode, isIndeterminate: false, selected: false, filterId: filter }));
    this.updateIsIndeterminate(group);
    return group;
  }

  updateIsIndeterminate(filterlist) {
    let that = this;
    each(filterlist, function (analyst) {
      analyst.isIndeterminate = ((!analyst.items.filter(i => {
        return i.selected
      }).length == 0) && (analyst.items.filter(i => {
        return i.selected
      }).length !== analyst.items.length)),
        analyst.selected = analyst.items.filter(i => {
          return i.selected
        }).length == analyst.items.length
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location !== nextProps.location) {
      this.setState({
        activeFiltersValues: [],
        activeSortFiltersValues: [],
        activeExclusionFiltersValues: [],
      });
    }

    const auth = loadState('auth');
    const userPermission = auth !== undefined && auth.user !== undefined ? auth.user.parsedPermissions : undefined;
    if (this.state.userPermission == undefined) {
      this.setState({
        userPermission
      });
    }
  }

  onKeyPress(event) {
    const eventCode = event.code ? (event.code + '_' + event.ctrlKey) : event.key + '_' + event.ctrlKey;
    switch (eventCode) {
      case KeyConstants.ESCAPE_BUTTON:
      case KeyConstants.ESCAPE_KEY_CODE_BUTTON:
        this.closeBanner();
        break;
    }
  }

  getDataForQueueMgmtLanding(regionCode, queueId, userId, pageNumber, size, sortArr, queueSearchView, lazyLoad, acquirerAccessCode) {
    lazyLoad = false;
    const queueMetaDataClone = { ...this.state.queueMetaData };
    queueMetaDataClone.dataColumns = [...this.state.dataColumns];
    return getDataForQueueMgmtLanding(regionCode, queueId, userId, pageNumber, size, sortArr, queueSearchView, acquirerAccessCode)
      .then((apiResponse) => {
        const formattedData = apiResponse.data.content;
        this.setState((prevState) => ({
          queueMetaData: queueMetaDataClone,
          caseData: lazyLoad ? prevState.caseData.concat(formattedData) : formattedData,
          isLoading: false,
          sortArr,
          agLoader: false,
          isCurrentlySavedFilters: false,
          statusErrorCode: apiResponse.status.statusCode,
        }));
        scroll(0, 0);
      })
      .catch((error) => {
        this.setState({ isLoading: false, statusErrorCode: error && error.response && queueId != 69 ? error.response.status : undefined });
        console.log('Error Occured while fetching data based on global applied filters', error);
      });
  }

  formatResponseCommon(response, elementId) {
    let formattedData = this.getFormattedResponse(response, elementId);
    this.setState({
      [elementId]: formattedData,
    }, () => {
      this.getMultiSelectFilterValues();
    })
  }

  getFiltersBasedOnSearchTypeId(filterTypeId) {
    let mandatoryCreateQueueFilterList = [];
    let availableCreateQueueFilterList = [];
    let activeSortFilterList = [];
    let availableSortFilterList = [];
    let activeExclusionFilterList = [];
    let availableExclusionFilterList = [];
    return getFiltersBasedOnSearchTypeId(filterTypeId, true)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          {
            const acquirerCode =this.state.selectedInput?.value?.acquirerAccessCode;

        const isGPXorGPN = acquirerCode === 'GPX';
                const binConfigCreateQueue = [
                 'cq_participantId',
                 'cq_businessLine',
                  'cq_fiid'
                  ];
                const binConfigExclusion = [
                  'cq_ex_participantId',
                  'cq_ex_businessLine',
                  'cq_ex_fiid'
                  ];

            apiResponse.data.filterElements
                .filter(obj => {
                                  if (
                                      binConfigCreateQueue.includes(obj.elementId)
                                  ) {
                                    return isGPXorGPN;
                                  }

                                  return obj.elementSection === 'create_queue';
                                })
              .map((filterElementItem) => {
                filterElementItem.elementMandatory ?
                  mandatoryCreateQueueFilterList.push(filterElementItem) :
                  availableCreateQueueFilterList.push(filterElementItem);
              });
            apiResponse.data.filterElements
              .filter(obj => obj.elementSection == "sort")
              .map((filterElementItem) => {
                filterElementItem.elementMandatory ?
                  activeSortFilterList.push(filterElementItem) :
                  availableSortFilterList.push(filterElementItem);
              });
            apiResponse.data.filterElements
              .filter(obj => {
                                  if
                                    (binConfigExclusion.includes(obj.elementId)) {
                                    return isGPXorGPN;
                                  }
               return obj.elementSection == "exclusion"})
              .map((filterElementItem) => {
                filterElementItem.elementMandatory ?
                  activeExclusionFilterList.push(filterElementItem) :
                  availableExclusionFilterList.push(filterElementItem);
              });
          }
          this.setState({
            activeFilters: formatActiveFilters(addCreateQueueFilterValidations(mandatoryCreateQueueFilterList)),
            availableFilters: formatAvailableFilters(addCreateQueueFilterValidations(availableCreateQueueFilterList)),
            duplicateAvailableFilters: formatAvailableFilters(addCreateQueueFilterValidations(availableCreateQueueFilterList)),
            activeSortFilters: formatActiveFilters(this.state.formattedActiveSortFilters),
            availableSortFilters: formatAvailableFilters(availableSortFilterList),
            duplicateActiveSortFilters: formatActiveFilters(activeSortFilterList),
            duplicateAvailableSortFilters: formatAvailableFilters(availableSortFilterList),
            activeExclusionFilters: formatActiveFilters(activeExclusionFilterList),
            availableExclusionFilters: formatAvailableFilters(availableExclusionFilterList),
            duplicateAvailableExclusionFilters: formatAvailableFilters(availableExclusionFilterList),
            filterTypeId: apiResponse.data.filterTypeId,
            isLoading: false,
          },
            () => this.afterSetState()
          );

        }
      })
      .catch((error) => {
        this.setState({
          isLoading: false
        })
        console.log('Error Occured while fetching filter values based on element id', error);
      })
  }

  afterSetState = () => {
    let commonArr;
    let acquirerAccessList = getAcquirerAccessList();
    commonArr = [...this.state.activeFilters, ...this.state.availableFilters, ...this.state.activeSortFilters, ...this.state.availableSortFilters, ...this.state.activeExclusionFilters, ...this.state.availableExclusionFilters];
    commonArr.forEach((filter) => {
      if ((filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH') && urlRelativeMapping[filter.elementId]) {
        if ((filter.elementId === 'cq_card_brand' || filter.elementId === 'cq_reason_code') && acquirerAccessList) {
          getFilterValuesBasedOnElementIdWithAcquirer(filter.elementId, acquirerAccessList)
            .then((response) => {
              if (response.status.statusCode === 2000) {
                this.formatResponseCommon(response, filter.elementId);
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              })
              console.log('Error Occured while fetching filter values based on element id', error);
            });
        } else if (filter.elementId === "cq_ex_corp_region") {
          getFilterValuesBasedOnElementId(filter.elementId)
            .then((response) => {
              if (response.status.statusCode === 2000) {
                let formattedData = this.getFormattedResponse(response, filter.elementId);
                this.setState({
                  [filter.elementId]: formattedData,
                }, () => {
                  this.getExclusionFilterValues();
                })
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              })
              console.log('Error Occured while fetching filter values based on element id', error);
            });
        } else {
          getFilterValuesBasedOnElementId(filter.elementId)
            .then((response) => {
              if (response.status.statusCode === 2000) {
                this.formatResponseCommon(response, filter.elementId);
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              })
              console.log('Error Occured while fetching filter values based on element id', error);
            });
        }
      }
      if (urlMapping[filter.elementId]) {
        fetchFilterValuesBasedOnElementId(filter.elementId, getAcquirerAccessList()).then((response) => {
          if (response.status.statusCode === 2000) {
            this.formatResponseCommon(response, filter.elementId);
          }
        })
          .catch((error) => {
            this.setState({
              isLoading: false,
            })
            console.log('Error Occured while fetching filter values based on element id', error);
          });
      }
      const acquirerCode = this.state.selectedInput?.value?.acquirerAccessCode;

        if ((acquirerCode === 'GPX'&& filter.elementId === 'cq_participantId') ||(acquirerCode === 'GPX'&& filter.elementId === 'cq_ex_participantId')) {

        fetchParticipantDetails(filter.elementId, acquirerCode)
          .then((response) => {
            if (response.status.statusCode === 2000) {
                  const participantList = response.data.participantIds.map(item => ({
                    value: item,
                    text: item,
                  }));

                  const businessLineList = response.data.businessLines.map(item => ({
                    value: item,
                    text: item,
                  }));

                  const fiidList = response.data.fiids.map(item => ({
                    value: item,
                    text: item,
                  }));

                  this.setState({
                    cq_participantId: participantList,
                    cq_businessLine: businessLineList,
                    cq_fiid: fiidList,

                    cq_ex_participantId: participantList,
                    cq_ex_businessLine: businessLineList,
                    cq_ex_fiid: fiidList,
                  }, () => {
                    this.getMultiSelectFilterValues();
                    this.getExclusionFilterValues();
                  });
            }
          })
          .catch((error) => {
            console.log(
              'Error Occured while fetching participant details',
              error
            );
          });
        }


      if (filter.elementId === 'cq_dspstn_ctgry') {
        getQueueLabels(true).then((response) => {
          if (response.status.statusCode === 2000) {
            this.formatResponseCommon(response, filter.elementId);
          }
        })
          .catch((error) => {
            this.setState({
              isLoading: false,
            })
            console.log('Error Occured while fetching queue labels', error);
          });
      }

      if (filter.elementId === 'cq_assigned_to') {
        let response = {
          data: [
            { name: 'Yes', value: 'Yes', },
            { name: 'No', value: 'No', },
          ]
        }
        this.formatResponseCommon(response, filter.elementId);
      }

      if ((filter.elementId).slice(0, (filter.elementId).lastIndexOf('_')) === 'sort') {
        getSortFiltersParamToCustomQueuePage().then((response) => {
          if (response.status.statusCode === 2000) {
            let formattedData = this.getFormattedResponse(response, filter.elementId);
            this.setState({
              [filter.elementId]: formattedData,
            }, () => {
              this.getSelectSortFilterValues(this.state.activeSortFilters, true);
            })
          }
        })
          .catch((error) => {
            this.setState({
              isLoading: false,
            })
            console.log('Error Occured while fetching category labels', error);
          });
      }
      if ((filter.elementId).slice(0, (filter.elementId).lastIndexOf('_')) === 'sort_odr') {
        getSortOrderToCustomQueuePage().then((response) => {
          if (response.status.statusCode === 2000) {
            let formattedData = this.getFormattedResponse(response, filter.elementId);
            this.setState({
              [filter.elementId]: formattedData,
            }, () => {
              this.getSelectSortFilterValues(this.state.activeSortFilters, true);
            })
          }
        })
          .catch((error) => {
            this.setState({
              isLoading: false,
            })
            console.log('Error Occured while fetching category labels', error);
          });
      }
    })
  }

  getMultiSelectFilterValues() {
    let activeFilters = [];
    activeFilters = this.state.activeFilters.map((filter) => {
      if (filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH' || filter.elementTypeName === 'DROPDOWN') {
        return {
          filterValues: this.state[filter.elementId],
          ...filter
        }
      } else {
        return filter;
      }
    });
    this.setState({
      formattedFilters: activeFilters,
    });
    return activeFilters;
  }

  updateCustomQueueLandingVal = (sortFilters, currentValues) => {
    this.setState({
      formattedActiveSortFilters: sortFilters,
      activeSortFilters: sortFilters
    })
  }

  capitalizeTheFirstLetterOfEachWord = (words) => {
    var separateWord = words.toLowerCase().split(" ");
    for (var i = 0; i < separateWord.length; i++) {
      separateWord[i] =
        separateWord[i].charAt(0).toUpperCase() + separateWord[i].substring(1);
    }
    return separateWord.join(" ");
  };

  getSelectSortFilterValues(sortFilters, isPrimary) {

    let getSortFilterList = [...this.state.activeSortFilters];
    let updatedSortFilterList = getSortFilterList.map((obj) => {
      let index = obj.actualNameId.lastIndexOf("_");
      let rowCount = obj.actualNameId.substr(index + 1);
      let prefix = obj.actualNameId.replaceAll("_", " ");
      let elementLabel = this.capitalizeTheFirstLetterOfEachWord(prefix);
      return {
        ...obj,
        elementLabel: elementLabel.replace("Odr", "Order"),
        rowCount: rowCount,
        values: null,
        id: obj.actualNameId,
        elementCategoryName: "EXACT",
        elementTypeName: "DROPDOWN",
      };
    });

    updatedSortFilterList.sort(
      (a, b) => parseFloat(a.rowCount) - parseFloat(b.rowCount)
    );

    let activeFilters = [];
    activeFilters = sortFilters.map((filter) => {
      if (filter.elementTypeName === 'DROPDOWN') {
        return {
          filterValues: this.state[filter.elementId],
          id: filter.elementId,
          ...filter
        }
      } else {
        return filter;
      }
    });
    isPrimary ?
      this.setState({
        formattedActiveSortFilters: updatedSortFilterList,
      }) :
      this.setState({
        formattedAvailableSortFilters: activeFilters,
      })
    return activeFilters;
  }

  getExclusionFilterValues() {
    let activeExclusionFilters = [];
    activeExclusionFilters = this.state.activeExclusionFilters.map((filter) => {
      if (filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH' || filter.elementTypeName === 'DROPDOWN') {
        return {
          filterValues: this.state[filter.elementId],
          ...filter
        }
      } else {
        return filter;
      }
    });
    this.setState({
      formattedExclusionFilters: activeExclusionFilters,
    })
    return activeExclusionFilters;
  }

  saveActiveDynamicFilters(activeFilters, newFilterValues, corp, regionCode, corpRegion) {
    const region = getUrlSearchParamValue(this.props.location.search, 'region');
    const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
    const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
    const acquirerAccessCode = getUrlSearchParamValue(this.props.location.search, 'acquirerAccessCode');

    let filterTypeId = this.state.filterTypeId;
    let activeFilterValues = newFilterValues;
    let searchFilterInputElements = splitMergedElementIdsFilterValues(activeFilterValues, activeFilters, corp, regionCode).filter(data => data.elementValue !== '');

    let queueSearchView = {
      filterTypeId: filterTypeId,
      searchFilterInputElements: searchFilterInputElements
    };
    if (this.state.isUpdate) {
      this.setState({
        isUpdateWarning: true,
        isVisible: true,
        updateFilterTypeId: filterTypeId,
        updateQueueSearchView: queueSearchView,
        updateActiveFilterValues: activeFilterValues,
      });
    }
    if (!this.state.isUpdate) {
      return postCreateQueueFilters(filterTypeId, activeFilterValues)
        .then((apiResponse) => {
          if (apiResponse == 'queueName already exists') {
            this.setState({
              isCreateFailure: true,
              isVisible: true,
            });
          }
          else if (apiResponse.status.statusCode === 2000) {
            this.setState({
              queueSearchView,
              isLoading: true,
              isCreated: true,
            });
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          console.log('Error Occured while saving dynamic active filters in database', error);
        })
    }
  }

  toggleFilterPane() {
    document.body.classList.add('instant-header');
    scroll(0, 0);
    this.setState(
      {
        isVisible: !this.state.isVisible,
        translations: { ...getTranslations(), createQueueFilterPane: "Create" },
        isUpdate: false,
        updateValues: [],
        showDynamicFilter: true,
      },
      () => {
        this.getFiltersBasedOnSearchTypeId(VITE_CQ_FILTERS_SEARCH_TYPE_ID)
        this.scrollTop();
      }
    );
  }

  checkSize() {
    this.props.setNotification([{
      title: `Error Occured`,
      descriptionStyle: "color: 'grey'",
      description: 'Your export request has exceeded the limitation of 25,000 rows.  Please apply additional filters to reduce of number rows.',
      type: 'danger',
      noActions: true,
      closeNotification: () => this.props.closeNotification(),
    }]);
    this.setState({
      setSize: false,
    })
  }

  onKeyDown(event) {
    if (event.keyCode == 27) {
      this.setState({
        displayFloatingPanel: false,
        selectedRows: [],
      });
    }
  }

  closeFilterPane = () => {
    scroll(0, 0);
    this.setState({ isVisible: false });
  }

  applyFilters(newValues, filterList, sortFilters, exclusionFilters, corp, region, corpRegion) {
    const newFilterValues = convertJsonObjectToArray(newValues, filterList);
    const newSortedValues = convertJsonObjectToArray(newValues, this.state.activeSortFilters);
    const newExclusionValues = convertJsonObjectToArray(newValues, exclusionFilters);

    let allFilterValues = newFilterValues.concat(newSortedValues, newExclusionValues).filter(item => {
      if (item)
        return item;
    });

    let allFilters = filterList.concat(this.state.activeSortFilters, exclusionFilters);
    if (newFilterValues.length === 0) {
      this.setState({
        isRequiredFilter: true,
        isVisible: true,
      })
    }
    else {
      this.setState({
        activeFiltersValues: mapActiveFilters(newFilterValues, filterList),
        isVisible: false,
        exportFilterTypeId: this.state.filterTypeId,
        corp: corp,
        region: region,
        corpRegion: corpRegion
      })

      this.saveActiveDynamicFilters(splitMergedElementIdsFilters(allFilters), mapActiveFilters(allFilterValues, allFilters), corp, region, corpRegion);
      this.getMultiSelectFilterValues();
    }
  }

  updateColumnsInfo(columns) {
    scroll(0, 0);
    this.setState({
      activeFilters: columns.activeColumns,
      availableFilters: columns.availableColumns,
    })
    if (columns.identifier) {
      const newFilterValues = convertJsonObjectToArray(columns.currentValues, columns.filterList);
      this.setState(() => ({
        activeFiltersValues: mapActiveFilters(newFilterValues.filter(data => data && data.id !== columns.identifier), columns.filterList)
      }))
    }
    const finalFilterElements = columns.activeColumns.map((filterElement) => {
      if (filterElement.elementTypeName === 'DYNAMIC_MULTISELECT' || filterElement.elementTypeName === 'GROUP_SEARCH' || filterElement.elementTypeName === 'DROPDOWN') {
        return {
          filterValues: this.state[filterElement.elementId],
          ...filterElement,
        };

      } else {
        return filterElement;
      }
    });

    this.setState({
      formattedFilters: finalFilterElements,
      dynamicFilterFlag: true,
    });

  }

  updateExclusionColumnsInfo(columns) {
    scroll(0, 0);
    this.setState({
      activeExclusionFilters: columns.activeColumns,
      availableExclusionFilters: columns.availableColumns,
    })
    if (columns.identifier) {
      const newFilterValues = convertJsonObjectToArray(columns.currentValues, columns.filterList);
      this.setState(() => ({
        activeExclusionFiltersValues: mapActiveFilters(newFilterValues.filter(data => data && data.id !== columns.identifier), columns.filterList)
      }))
    }
    const finalFilterElements = columns.activeColumns.map((filterElement) => {
      if (filterElement.elementTypeName === 'DYNAMIC_MULTISELECT' || filterElement.elementTypeName === 'GROUP_SEARCH' || filterElement.elementTypeName === 'DROPDOWN') {
        return {
          filterValues: this.state[filterElement.elementId],
          ...filterElement,
        };
      } else {
        return filterElement;
      }
    });

    this.setState({
      formattedExclusionFilters: finalFilterElements,
      dynamicFilterFlag: true,
    });
  }

  closeBanner() {
    this.setState({
      isRequiredFilter: false,
      isDeleteWarning: false,
      showErrorBanner: false,
      isQueueActive: false,
      isQueueInactive: false,
      isCreateFailure: false,
      isUpdateWarning: false,
    });
  }

  clearAllFilters() {
    this.clearGroupSearchValue();
    this.setState(
      {
        activeFiltersValues: [],
        activeSortFiltersValues: [],
        activeExclusionFiltersValues: [],
        savedFilters: mapSavedFilters(this.state.savedFilters),
        queueSearchView: {
          "filterTypeId": 0,
          "searchFilterInputElements": []
        },
        updateValues: [],
      }
    );
  }

  clearGroupSearchValue() {
    this.state.formattedFilters.map((element) => {
      if (element.elementTypeName === 'GROUP_SEARCH') {
        for (let i = 0; i < element.filterValues.length; i++) {
          element.filterValues[i].selected = false;
          let items = element.filterValues[i].items;
          for (let j = 0; j < items.length; j++) {
            items[j].selected = false;
          }
        }
      }
    })
    this.state.formattedExclusionFilters.map((element) => {
      if (element.elementTypeName === 'GROUP_SEARCH') {
        for (let i = 0; i < element.filterValues.length; i++) {
          element.filterValues[i].selected = false;
          let items = element.filterValues[i].items;
          for (let j = 0; j < items.length; j++) {
            items[j].selected = false;
          }
        }
      }
    })
  }

  scrollTop = () => {
    const divElement = document.getElementById("custom-queue-filter-pane");
    divElement.scrollIntoView({ behavior: 'smooth' });
  }

  // update queues
  updateQueue = (queue) => {
    getQueueData(queue.customQueueId).then((response) => {
      if (response == 'queueDeleted') {
        this.setState({
          queueDeletedException: true,
        });
      } else {
        let queueFilter = [
          {
            elementId: "cq_label",
            elementMandatory: true,
            elementSection: "create_queue",
            id: "cq_label",
            updatedId: "cq_label",
            v1: response.data.queuecategorycode, //DE
            value: response.data.queuecategorycode,
            values: null
          },
          {
            elementId: "cq_base_queue",
            elementMandatory: true,
            elementSection: "create_queue",
            id: "cq_base_queue",
            updatedId: "cq_base_queue",
            v1: response.data.subcategorycode, //EUC
            value: response.data.subcategorycode,
            values: null
          },
          {
            elementId: "cq_name",
            elementMandatory: true,
            elementSection: "create_queue",
            id: "cq_name",
            updatedId: "cq_name",
            v1: response.data.queuelabel, // Fraud chrge back
            value: response.data.queuelabel,
            values: null
          },
        ]
        responseData = [
          ...response.data.exclusionFilter,
          ...response.data.sortFilter,
          ...response.data.queueFilter,
          ...queueFilter
        ]

        let activeFilters = this.state.activeFilters;
        let availableFilters = this.state.availableFilters;
        let groupSearch = [...activeFilters, ...availableFilters].filter(item => item.elementTypeName == "GROUP_SEARCH")
        let groupSerachValues = [];
        groupSearch.forEach(item => {
          responseData.forEach(rItem => {
            if (item.elementId == rItem.elementId) {
              groupSerachValues.push(rItem)
            }
          })
        })

        responseData.forEach(item => {
          this.state.availableFilters.forEach(ava => {
            if (item.elementId == ava.elementId) {
              activeFilters.push(ava);
              if (ava.elementTypeName !== "DYNAMIC_MULTITEXT") {
                availableFilters = availableFilters.filter(i => i.elementId != ava.elementId)
              }
            }
          })
        })

        let activeSortFilters = response.data.sortFilter;
        let availableSortFilters = this.state.availableSortFilters;

        let activeExclusionFilters = this.state.activeExclusionFilters;
        let availableExclusionFilters = this.state.availableExclusionFilters;
        responseData.forEach(item => {
          this.state.availableExclusionFilters.forEach(ava => {
            if (item.elementId == ava.elementId) {
              activeExclusionFilters.push(ava);
              if (ava.elementTypeName !== "DYNAMIC_MULTITEXT") {
                availableExclusionFilters = availableExclusionFilters.filter(i => i.elementId != ava.elementId)
              }
            }
          })
        })

        this.setState({
          activeFilters,
          availableFilters,
          activeSortFilters,
          availableSortFilters,
          activeExclusionFilters,
          availableExclusionFilters,
          formattedActiveSortFilters: [],
          updateValues: responseData,
          updateValueForEnableAndDisable: responseData,
          isVisible: true,
          translations: { ...getTranslations(), createQueueFilterPane: "Update" },
          isUpdate: true,
          showDynamicFilter: false,
        }, () => {
          this.afterSetState();
          this.scrollTop();
        })
      }
    })
  }

  goToQueueLanding = (queueId) => {
    const regionCode = this.state.selectedInput.value.regionCode;
    const acquirerAccessCode = this.state.selectedInput.value.acquirerAccessCode;
    VITE_AVAILABLE_QUEUES.indexOf(queueId) == -1 ? this.props.history.push(`/queue-management-landing?region=${regionCode}&queueid=${queueId}&acquirerAccessCode=${acquirerAccessCode}`) : (queueId == 15 ? this.props.history.push(`/queue/${queueId}?regionCode=${regionCode}`) : this.props.history.push(`/queue/${queueId}`));
  };

  isThreeDots({ action, queue }) {
    if (queue != undefined)
      this.setState({
        selectedQueue: queue,
      })
    if (action?.name == "Edit") {
      this.setState({ // this duplicate values created from API call
        activeFilters: this.state.activeFilters.filter(item => item.elementMandatory),
        availableFilters: this.state.duplicateAvailableFilters,
        activeSortFilters: this.state.duplicateActiveSortFilters.filter((item, index) => index <= 1),
        availableSortFilters: this.state.duplicateAvailableSortFilters,
        activeExclusionFilters: [],
        availableExclusionFilters: this.state.duplicateAvailableExclusionFilters,
      }, () => {
        this.updateQueue(queue);
      })
    }
    if (action?.name == "Delete") {
      this.setState({
        isDeleteWarning: true,
      });
    }
    if (action?.name == 'Active') {
      this.updateQueueVisibility(queue.customQueueId, true);
    }
    if (action?.name == 'Inactive') {
      this.updateQueueVisibility(queue.customQueueId, false);
    }
  };

        handleSelectionChange(selectedItem) {
          let actionCategoryCode;
        if (this.state.buttonAnalyst) {
          actionCategoryCode = "PDAN";
        }
        if (this.state.buttonMerchant) {
          actionCategoryCode = "PDMR";
        }
        if (this.state.buttonInternal) {
          actionCategoryCode = "PDIN";
        }

        if (selectedItem) {
          this.setState(
            {
              selectedInput: selectedItem,

              cq_participantId: [],
              cq_businessLine: [],
              cq_fiid: [],
            },
            () => {

              this.getSubQueueList(
                actionCategoryCode,
                selectedItem.value.regionCode
              );

              this.getFiltersBasedOnSearchTypeId(
                VITE_CQ_FILTERS_SEARCH_TYPE_ID
              );
            }
          );
        }
      }

  changeButton(e) {
    const queueGroupCode = this.state.selectedInput.value.regionCode;
    let actionCategoryCode;
    if (e.target.id == "Analyst") {
      actionCategoryCode = "PDAN";
      this.getSubQueueList(actionCategoryCode, queueGroupCode);
      this.setState({ buttonAnalyst: true, buttonMerchant: false, buttonInternal: false });
    }
    if (e.target.id == "Merchant") {
      actionCategoryCode = "PDMR"
      this.getSubQueueList(actionCategoryCode, queueGroupCode);
      this.setState({ buttonAnalyst: false, buttonMerchant: true, buttonInternal: false });
    }
    if (e.target.id == "Internal") {
      actionCategoryCode = "PDIN"
      this.getSubQueueList(actionCategoryCode, queueGroupCode);
      this.setState({ buttonAnalyst: false, buttonMerchant: false, buttonInternal: true });
    }
  }

  getSubQueueList(actionCategoryCode, queueGroupCode) {
    return getSubQueueList(actionCategoryCode, queueGroupCode).then((response) => {
      this.setState({
        subQueueList: response.data,
      });
    }).catch((error) => {
      console.log('error received while fetching data columns based on sub queue list page', error);
    });
  }

  getQueueGroupList() {
    let actionCategoryCode = "PDAN";
    let acquirerAccessList = getAcquirerAccessList();
    let userId = JSON.parse(sessionStorage.getItem('state')).auth.user.userId;
    if (acquirerAccessList.length !== 0) {
      return getQueueGroupList(acquirerAccessList, userId)
        .then((apiResponse) => {
          const formattedRegionList = apiResponse.data.map((item) => {
            let regionListValue = { regionCode: item.queueGroupCode, acquirerAccessCode: item.acquirerAccessCode, isDefaultRegion: item.defaultRegion };
            return {
              text: item.queueGroupLabel,
              value: regionListValue,
            };
          });

          let defaultRegionIndex= formattedRegionList.findIndex(region=> region.value.isDefaultRegion==true)
          if(defaultRegionIndex == -1){
            defaultRegionIndex = 0
          }
          // TODO:  The default dropdown list should be first till now, but this should be changed to user specific.
          this.setState({
            regionDataList: formattedRegionList,
            selectedInput: formattedRegionList[defaultRegionIndex],
          }, ()=> {
            this.getSubQueueList(actionCategoryCode, this.state.selectedInput.value.regionCode);
          });

        })
        .catch((error) => {
          console.log('error received while fetchiformattedRegionListng list of regions', error);
        });
    }
  }

  fetchQueueLabels() {
    getQueueLabels(false).then(response => {
      this.setState({ queueLabels: response.data });
    })
  }

  getCategoryLabels() {
    getCategoryLabels().then(response => {
      this.setState({ categoryLabels: response.data })
      Labels = response.data.filter(obj => obj.queueIndicator == "1");
    })
  }

  deleteSubQueue() {
    this.setState({
      isDeleteWarning: false,
    }
    );
    deleteSubQueue(this.state.selectedQueue.customQueueId).then(response => {
      if (response.status.statusCode == 2000 || response.status.statusCode == 200) {
        this.setState({
          isDeleteSuccess: true,
        });
      }
    }).catch((error) => {
      console.log('Error occured while deleting sub queue', error);
      this.setState({
        showErrorBanner: true,
      });
    });
  }

  updateQueueVisibility(customQueueId, isActiveInactive) {
    updateQueueVisibility(customQueueId, isActiveInactive).then(response => {
      if (response == 'queueDeleted') {
        this.setState({
          queueDeletedException: true,
        });
      } else if (response.status.statusCode == 2000 || response.status.statusCode == 200) {
        let actionCategoryCode;
        if (this.state.buttonAnalyst) {
          actionCategoryCode = "PDAN";
        }
        if (this.state.buttonMerchant) {
          actionCategoryCode = "PDMR";
        }
        if (this.state.buttonInternal) {
          actionCategoryCode = "PDIN";
        }
        this.getSubQueueList(actionCategoryCode, this.state.selectedInput.value.regionCode);
        if (isActiveInactive == true) {
          this.setState({ isQueueActive: true, });
        } else {
          this.setState({ isQueueInactive: true, });
        }
      }
    }).catch((error) => {
      console.log('Error occured while activating / deactivating sub queue', error);
      this.setState({
        showErrorBanner: true,
      }
      );
    });
  }

  saveUpdateQueue = () => {
    this.setState({
      isUpdateWarning: false,
    }, () => {
      return postUpdateQueueFilters(this.state.updateFilterTypeId, this.state.updateActiveFilterValues, this.state.selectedQueue.customQueueId)
        .then((apiResponse) => {
          if (apiResponse == 'queueName already exists') {
            this.setState({
              isCreateFailure: true,
              isVisible: true,
            }, () => {
              this.scrollTop();
            });
          } else if (apiResponse == 'queueDeleted') {
            this.setState({
              queueDeletedException: true,
            });
          } else if (apiResponse.status.statusCode === 2000) {
            this.setState({
              queueSearchView: this.state.updateQueueSearchView,
              isLoading: true,
              isUpdatedSuccess: true,
              isUpdate: false
            });
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false, isUpdatedSuccess: false });
          console.log('Error Occured while updating dynamic active filters in database', error);
        })
    })
  }

  showBanner() {
    return (
      <div>
        {this.state.isCreated && (
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Success"
              description="The selected queue has been created."
              type="success"
              successOnly={true}
              primaryButtonText="OK, GREAT"
              onClose={this.reLoadFullPage}
              primaryButtonAction={this.reLoadFullPage}
            />
          </ImagePortal>
        )}
        {this.state.isCreateFailure && (
          <ImagePortal>
            <ResponseBanner
              title="Error !"
              type="danger"
              description="Queue name already exists."
              primaryButtonAction={this.closeBanner}
              cancelButtonText="CANCEL"
              onClose={this.closeBanner}
              primaryButtonText="OK"
            />
          </ImagePortal>
        )}
        {(this.state.isUpdatedSuccess &&
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Success"
              description="The selected queue has been updated."
              type="success"
              successOnly={true}
              primaryButtonText="OK, GREAT"
              onClose={this.reLoadFullPage}
              primaryButtonAction={this.reLoadFullPage}
            />
          </ImagePortal>
        )}
        {this.state.isDeleteWarning &&
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Are you sure you want to delete this queue?"
              description="Please advise users to exit this queue before making this change."
              type="warning"
              onClose={this.closeBanner}
              cancelButtonText="DO NOT DELETE"
              secondaryButtonAction={this.closeBanner}
              primaryButtonText="YES, PLEASE DELETE"
              primaryButtonAction={this.deleteSubQueue}
            />
          </ImagePortal>}
        {this.state.isDeleteSuccess &&
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Success"
              description="The selected queue has been deleted."
              type="success"
              successOnly={true}
              primaryButtonText="OK, GREAT"
              onClose={this.reLoadFullPage}
              primaryButtonAction={this.reLoadFullPage}
            />
          </ImagePortal>
        }
        {this.state.isQueueActive &&
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Success"
              description="The selected queue is now active."
              type="success"
              successOnly={true}
              primaryButtonText="OK, GREAT"
              onClose={this.closeBanner}
              primaryButtonAction={this.closeBanner}
            />
          </ImagePortal>
        }
        {this.state.isQueueInactive &&
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Success"
              description="The selected queue is now inactive."
              type="success"
              successOnly={true}
              primaryButtonText="OK, GREAT"
              onClose={this.closeBanner}
              primaryButtonAction={this.closeBanner}
            />
          </ImagePortal>
        }
        {this.state.queueDeletedException &&
          <ImagePortal>
            <ResponseBanner
              title="Error !"
              type="danger"
              description="This queue is already deleted and cannot be modified."
              primaryButtonAction={this.reLoadFullPage}
              successOnly={true}
              onClose={this.reLoadFullPage}
              primaryButtonText="OK"
            />
          </ImagePortal>
        }
        {this.state.isUpdateWarning &&
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="Are you sure you want to edit this queue?"
              description="Please advise users to exit this queue before making this change."
              type="warning"
              onClose={this.closeBanner}
              cancelButtonText="DO NOT UPDATE"
              secondaryButtonAction={this.closeBanner}
              primaryButtonText="YES, PLEASE UPDATE"
              primaryButtonAction={this.saveUpdateQueue}
            />
          </ImagePortal>
        }
      </div>
    );
  }

  resetScrollPos() {
    this.state.scrollPos = 0;
  }

  render() {
    window.document.title = 'Create Custom Queue';
    let pr = 0;
    let de = 0;
    let sp = 0;
    let acquirerList = getAcquirerAccessList();
    const filterPaneTriggerClasses = classnames('filter-pane-trigger', {
      'disabled-cq-pane-button': this.state.isUpdate
    });
    if (this.props.user !== undefined && this.props.user.parsedPermissions.queue.createQueue && acquirerList.length !== 0 && this.state.statusErrorCode !== 403) {
      return (
        <section>
          {this.state.setSize == true &&
            this.checkSize()
          }
          {this.showBanner()}
          {this.state.showErrorBanner && (
            <ImagePortal>
              <ResponseBanner
                title="Error !"
                description="Error"
                type="danger"
                primaryButtonAction={this.closeBanner}
                cancelButtonText="CANCEL"
                onClose={this.closeBanner}
              />
            </ImagePortal>
          )}
          <div className={this.props.isSearchActive ? 'main-content--header reports-container--header secondary-header' : "main-content--header reports-container--header"} style={{ zIndex: 3 }}>

            <div className="flex-left">
              <h1>Custom Queues</h1>
              {this.state.generalQueueMetaData.dataColumns?.map((component, index) => {
                return (
                  isObject(component.dropDownselection) &&
                  this.state.selectedInput.text &&
                  <div className="region-dropdown-view-custom">
                    <DropDownList
                      dropDownList={this.state[component.dropDownselection.defSelectKey]}
                      selectedItemText={this.state.selectedInput.text}
                      selectDropdownItem={this.handleSelectionChange}
                      extraStyle={{ left: 5, width: 150 }}
                      wrapperButtonStyle={{ left: 0, width: 'max-content' }}
                      isFocus={false}
                    />
                  </div>
                );
              }
              )}
            </div>
            {this.state.userPermission !== undefined && this.state.userPermission.case.masterPermission && <div className="flex-right" style={{ paddingRight: 13 }}>
              <div style={{ cursor: this.state.isUpdate ? 'not-allowed' : 'pointer' }}>
                <div
                  role="button"
                  tabIndex={0}
                  id="Create Queue_filter_btn"
                  className={filterPaneTriggerClasses}
                  onClick={this.state.isUpdate ? undefined : this.toggleFilterPane}
                  aria-expanded={this.state.isVisible}
                >
                  <span className="gd-report-runner__filter-toggle">Create Queue</span>
                </div>
              </div>
            </div>}
          </div>

          <div className="main-content--wrapper" style={{ width: '100%' }}>
            <div className={this.props.isSearchActive ? '' : 'gd-filter-pane__wrapper'}>
              <CustomQueueFilterPane
                applyFilters={this.applyFilters}
                closeFilterPane={this.closeFilterPane}
                currentValues={this.state.activeFiltersValues}
                dateFormat={this.state.dateFormat}
                filterList={this.state.formattedFilters}
                sortFilterList={this.state.formattedActiveSortFilters}
                updateCustomQueueLandingVal={this.updateCustomQueueLandingVal}
                availableSortFilterList={this.state.formattedAvailableSortFilters}
                exclusionFilterList={this.state.formattedExclusionFilters}
                isVisible={this.state.isVisible}
                translations={this.state.translations}
                reportName="Received Disputes_filterPane"
                extraClass="some-class"
                resetScrollPos={this.resetScrollPos}
                showDynamicFilter={true}
                activeFilters={this.state.activeFilters}
                availableFilters={this.state.availableFilters}
                updateColumnsInfo={this.updateColumnsInfo}
                updateExclusionColumnsInfo={this.updateExclusionColumnsInfo}
                updateIsIndeterminate={this.updateIsIndeterminate}
                listHeight="auto"
                clearAllFilters={this.clearAllFilters}
                activeSortFilters={this.state.activeSortFilters}
                availableSortFilters={this.state.availableSortFilters}
                updateValues={this.state.updateValues}
                activeExclusionFilters={this.state.activeExclusionFilters}
                availableExclusionFilters={this.state.availableExclusionFilters}
                isUpdate={this.state.isUpdate}
                updateValueForEnableAndDisable={this.state.updateValueForEnableAndDisable}
              />
            </div>
          </div>

          {/* HomePage2 */}
          <div className="SubQueue-custom">
            <div className="option-buttons-custom">
              <button id="Analyst" className={this.state.buttonAnalyst ? "button-click-custom" : "button-Unclick-custom"}
                onClick={(e) => this.changeButton(e)}> {this.state.queueLabels[0]?.categoryDescription} </button>
              <button id="Merchant" className={this.state.buttonMerchant ? "button-click-custom" : "button-Unclick-custom"}
                onClick={(e) => this.changeButton(e)}>  {this.state.queueLabels[2]?.categoryDescription} </button>
              <button id="Internal" className={this.state.buttonInternal ? "button-click-custom" : "button-Unclick-custom"}
                onClick={(e) => this.changeButton(e)}> {this.state.queueLabels[1]?.categoryDescription} </button>
            </div>
            <div>{
              this.state.pendingCases !== undefined && this.state.pendingCases.dataColumns !== undefined && this.state.pendingCases.dataColumns?.length > 0 &&
              this.state.pendingCases.dataColumns?.map((cases, index) => {
                return (
                  <CaseCountDetail
                    parentComponentName="CreatCustomQueLanding"
                    user={this.props.user}
                    customQueue={this.state.subQueueList !== undefined && this.state.subQueueList.filter(obj => obj.queueCategoryCode == null)[0]}
                  />
                );
              })
            }</div>
            {/* Sub Queue*/}
            <div className="homepage-subQueue-custom">
              {Labels !== undefined &&
                Labels.map((label, index) => {
                  return (
                    <div className='subQueue-container-custom' key={index}>
                      {
                        <div className="title-subQueue-custom">
                          <QueueList
                            id={label.queueCategoryCode}
                            name={label.queueDescription}
                            title={true}
                            subQueue={true}
                            cursorView={false}
                          />
                        </div>}
                      <div className="pending-cart-custom">
                        {
                          <div className='pending-list-container'>
                            {
                              Labels === undefined && <BVLoader20 />
                            }
                            {this.state.subQueueList !== undefined && this.state.subQueueList.map((row, index) => {
                              if (row.queueCategoryCode == label.queueDescription) {
                                if (row.queueCategoryCode == 'Priority') {
                                  pr = pr + 1;
                                  if (pr < 4) {
                                    row.prFirstThreeRows = true;
                                  } else {
                                    row.prFirstThreeRows = false;
                                  }
                                }
                                if (row.queueCategoryCode == 'Default') {
                                  de = de + 1;
                                  if (de < 4) {
                                    row.deFirstThreeRows = true;
                                  } else {
                                    row.deFirstThreeRows = false;
                                  }
                                }
                                if (row.queueCategoryCode == 'Specialty') {
                                  sp = sp + 1;
                                  if (sp < 4) {
                                    row.spFirstThreeRows = true;
                                  } else {
                                    row.spFirstThreeRows = false;
                                  }
                                }
                                return (<div key={index}>
                                  <QueueList
                                    id={row.queueCategoryCode}
                                    name={row.queueLabel}
                                    subQueue={true}
                                    onViewClick={this.isThreeDots}
                                    selecedQueue={row}
                                    trailingText={"..."}
                                    parentComponentName="CreatCustomQueLanding"
                                    popupContent={[
                                      { id: 0, name: row.queueVisibilityInd ? 'Inactive' : 'Active', },
                                      { id: 1, name: 'Edit', },
                                      { id: 2, name: 'Delete', },
                                    ]}
                                    visibilityInd={row.queueVisibilityInd}
                                    poupUpBottom={(row.prFirstThreeRows || row.deFirstThreeRows || row.spFirstThreeRows) ? '' : 'popup-menu-above'}
                                    cursorView={false}
                                  />
                                </div>);
                              }
                            })}
                            {
                              this.state.subQueueList !== undefined ?
                                ((label.queueCategoryCode == 'PR' && pr == 0) ||
                                  (label.queueCategoryCode == 'DE' && de == 0) ||
                                  (label.queueCategoryCode == 'SP' && sp == 0))
                                  ? <div className="subQueue-message-view-custom">No custom queues to display.</div> : ''
                                : <BVLoader20 callingComponent="CreateCustomQueueLanding" />
                            }
                          </div>
                        }</div>
                    </div>
                  );
                })}
            </div>
          </div>

        </section >
      );
    } else {
      return (
        <div>
          <EmptyState
            translations={{
              emptyStateHeading: acquirerList.length === 0 && this.props.user.parsedPermissions.queue.createQueue ? this.state.emptyStateNoPermissionsHeading : this.state.emptyStateHeading,
              emptyStateDescription: acquirerList.length === 0 && this.props.user.parsedPermissions.queue.createQueue ? this.state.emptyStateNoPermissionsDesc : this.state.emptyStateDescription
            }}
          />
        </div>
      );
    }
  }
}

CreateCustomQueueLanding.propTypes = {
  dataColumns: PropTypes.array.isRequired,
  setNotification: PropTypes.func.isRequired,
  fetchDataColumns: PropTypes.func.isRequired,
  closeNotification: PropTypes.func.isRequired,
  setCords: PropTypes.func.isRequired,
  resetCords: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  dataColumns: state.dataColumns?.columns,
  isSearchActive: state.appSearch.isSearchActive,
  user: state.auth.user,
  filters: state.searchFilter.filters,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataColumns: (pageId) => dispatch(fetchDataColumns(pageId)),
    setNotification: (banner) => dispatch(dangerNotificationBanner(banner)),
    closeNotification: () => dispatch(closeNotificationBanner()),
    setCords: (cordsData) => dispatch(setCords(cordsData)),
    resetCords: () => dispatch(resetCords()),
    setSearchOpenFlag: (isSearchActive) => {
      dispatch(setSearchOpenFlag(isSearchActive));
    },
    fetchFilterElements: (searchTypeId) => {
      dispatch(fetchFilterElements(searchTypeId));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateCustomQueueLanding));
